import { createSlice } from "@reduxjs/toolkit";

// En tu downloadSlice.js o el archivo que contenga tus slices...
export const downloadSlice = createSlice({
  name: "download",
  initialState: {
    progress: 0,
    loaded: 0,
    total: 0,
    // ... otros estados si los hay
  },
  reducers: {
    updateDownloadProgress: (state, action) => {
      const { loaded, total } = action.payload;
      state.loaded = loaded;
      state.total = total;
      state.progress = (loaded / total) * 100;
    },
    restoreDownloadProgress: (state) => {
      state.loaded = 0;
      state.total = 0;
      state.progress = 0;
    },
  },
  extraReducers: {
    // ... tus otros reducers si los hay
  },
});

export const { updateDownloadProgress, restoreDownloadProgress } =
  downloadSlice.actions;
export default downloadSlice.reducer;
